import { render, staticRenderFns } from "./sensitive-text.vue?vue&type=template&id=0f94fa6a&"
import script from "./sensitive-text.vue?vue&type=script&lang=js&"
export * from "./sensitive-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports